/* 
* Anthony Dittus
* September 28, 2020
*/
define(
	'Anchorgroup.GridCartAdder.GridCartAdderMod'
	, [
		'Anchorgroup.GridCartAdder.GridCartAdderMod.View'
		, 'Anchorgroup.GridCartAdder.GridCartAdderMod.Subtotal',
		'Facets.ItemCell.View',
		'underscore'
	]
	, function (
		GridCartAdderModView
		, GridCartAdderModSubtotalView,
		FacetsItemCellView,
		_
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				/** @type {LayoutComponent} */
				var Cart = container.getComponent('Cart');
				var layout = container.getComponent('Layout');
				//console.log("GRID CART ADDER: Extension Initiated");

				// layout.registerView('ProductFields.PDP', function () {//facets_item_cell_list.tpl
				// 	return new GridCartAdderModView({ container: container });
				// }); 

				// layout.addChildView('Product.QuantitySelect', function () {
				// 	return new GridCartAdderModView({
				// 		container: container,
				// 		Cart: Cart
				// 	});
				// });


				_.extend(FacetsItemCellView.prototype, {
					childViews: _.extend(FacetsItemCellView.prototype.childViews,
						{
							'ItemViews.Subtotal': function () {
								var itemId = this.model.get('internalid');
								return new GridCartAdderModSubtotalView({
									itemId: itemId, 
									Cart: Cart 
								});
							}
						})
				});

				_.extend(FacetsItemCellView.prototype, {
					childViews: _.extend(FacetsItemCellView.prototype.childViews,
						{
							'Product.QuantitySelect': function () {
								var itemId = this.model.get('internalid');
								return new GridCartAdderModView({
									itemId: itemId, 
									Cart: Cart,
									container: container
								});
							}
						})
				});


			}
		};
	});
